<template>
  <basic-layout-dynamic :hide-footer="true">
    <div class="container">
      <div class="contents">
        <gl-select-company :company.sync="company" />

        <div class="pfv-graph">
          <div class="title-text">客点数 × ID回数</div>
          <pfv-image :url="imageUrls[0]" />
        </div>

        <div class="pfv-graph">
          <div class="title-text">点単価 × 客点数</div>
          <pfv-image :url="imageUrls[1]" />
        </div>

        <div class="pfv-graph">
          <pfv-image :url="imageUrls[2]" />
        </div>

        <md-table class="cluster-table">
          <md-table-row>
            <md-table-head></md-table-head>
            <md-table-head>クラスタ名</md-table-head>
            <md-table-head md-numeric>{{
              $store.state.labels.evaluations.qty_per_receipt
            }}</md-table-head>
            <md-table-head md-numeric>{{
              $store.state.labels.evaluations.customer_count
            }}</md-table-head>
            <md-table-head md-numeric>{{
              $store.state.labels.evaluations.amount_per_qty
            }}</md-table-head>
            <md-table-head md-numeric>
              {{ $store.state.labels.evaluations.amount_per_qty }}
              （最大値）</md-table-head
            >
            <md-table-head md-numeric
              >{{
                $store.state.labels.evaluations.amount_per_qty
              }}（最小値）</md-table-head
            >
          </md-table-row>
          <md-table-row v-if="clusterData.length === 0">
            <md-table-cell>
              <gl-sub-text>読込中...</gl-sub-text>
            </md-table-cell>
          </md-table-row>
          <md-table-row v-for="row in clusterData" :key="row.pfvCode">
            <md-table-cell>
              <md-icon v-bind:style="{ color: row.color }"
                >supervised_user_circle</md-icon
              >
            </md-table-cell>
            <md-table-cell>
              <a
                v-if="$store.getters.isAdmin"
                href="#"
                @click.prevent="openEditDialog(row.pfvCode, row.pfvName)"
                >{{ row.pfvName }}</a
              >
              <div v-else>
                {{ row.pfvName }}
              </div>
            </md-table-cell>
            <md-table-cell md-numeric>{{
              row.qtyPerReceipt | formatNumeric('0,0.00')
            }}</md-table-cell>
            <md-table-cell md-numeric>{{
              row.customerCount | formatNumeric('0,0')
            }}</md-table-cell>
            <md-table-cell md-numeric>{{
              row.amountPerQty | formatNumeric('0,0.00')
            }}</md-table-cell>
            <md-table-cell md-numeric>{{
              row.max | formatNumeric('0,0.00')
            }}</md-table-cell>
            <md-table-cell md-numeric>{{
              row.min | formatNumeric('0,0.00')
            }}</md-table-cell>
          </md-table-row>
        </md-table>

        <!-- クラスタの編集ダイアログ -->
        <md-dialog
          :md-active.sync="showClusterEditDialog"
          class="dialog-window"
        >
          <md-dialog-title>
            クラスタ名変更（{{ editingCluster.originalName }}）
          </md-dialog-title>
          <md-dialog-content>
            <md-field :class="{ 'md-invalid': hasInputError }">
              <label>新しいクラスタ名</label>
              <md-input
                v-model="editingCluster.editName"
                :maxlength="pfvNameMaxLength"
                required
              />
              <span class="md-error">
                {{ inputErrorMessage }}
              </span>
            </md-field>
          </md-dialog-content>
          <md-dialog-actions>
            <gl-button @click="showClusterEditDialog = false"
              >キャンセル</gl-button
            >
            <gl-button
              :disabled="hasInputError || clusterNameSaving"
              class="md-primary"
              @click="save"
              >{{ saveButtonText }}</gl-button
            >
          </md-dialog-actions>
        </md-dialog>
      </div>
    </div>
  </basic-layout-dynamic>
</template>

<script>
import GlSelectCompany from '@/components/common/GlSelectCompany.vue'
import PfvImage from '@/components/PfvImage.vue'

const PFV_NAME_MAX_LENGTH = 20

export default {
  components: { GlSelectCompany, PfvImage },
  data() {
    return {
      /**
       *クラスタ名に使用出来る最大文字数を定義しています。
       */
      pfvNameMaxLength: PFV_NAME_MAX_LENGTH,
      /**
       *クラスタ編集ダイアログの表示の切り替えスイッチです。
       */
      showClusterEditDialog: false,
      /**
       *参照選択している企業コードの保管場所です。
       */
      company: undefined,
      /**
       *参照選択している企業の画像URLの保管場所です。
       */
      imageUrls: [],
      /**
       *参照選択している企業pfvの保管場所です。
       */
      clusterData: [],
      /**
       *クラスタ名編集中のクラスタ情報
       */
      editingCluster: {
        id: undefined,
        originalName: undefined,
        editName: undefined,
      },
      clusterNameSaving: false,
    }
  },
  watch: {
    company() {
      if (!this.company) {
        return
      }

      this.imageUrls = []
      this.clusterData = []

      // TODO PFVデータの取得は少々時間がかかるので、レスポンス前に企業変更が行われる
      //      可能性は大いにある。企業が変わったらレスポンス待機をキャンセルして
      //      新しいリクエストを飛ばすようにする（RxJsでやると簡単）
      Promise.all([
        this.$repositories.get('pfv').getImageUrls(this.company),
        this.$repositories.get('pfv').get(this.company),
      ]).then(([imageUrls, clusterData]) => {
        this.imageUrls = imageUrls
        this.clusterData = clusterData
      })
    },
  },
  computed: {
    /**
     * クラスタ名の入力にエラーがあった場合のメッセージ
     */
    inputErrorMessage() {
      if (
        this.clusterData.some(c => c.pfvName === this.editingCluster.editName)
      ) {
        return '既に存在しているクラスタ名です。'
      }
      if (!this.editingCluster.editName) {
        return '入力して下さい。'
      } else {
        return ''
      }
    },
    /**
     *クラスタ名入力のエラーメッセージの有無
     */
    hasInputError() {
      if (!this.inputErrorMessage) {
        return false
      } else {
        return true
      }
    },
    saveButtonText() {
      return this.clusterNameSaving ? '保存しています...' : '保存'
    },
  },

  methods: {
    /**
     *新しいクラスター名を保存します。
     */
    async save() {
      this.clusterNameSaving = true

      await this.$repositories
        .get('pfv')
        .post(
          this.company,
          this.editingCluster.id,
          this.editingCluster.editName,
        )
      this.clusterData = await this.$repositories.get('pfv').get(this.company)

      this.showClusterEditDialog = false
      this.clusterNameSaving = false
    },
    /**
     *クラスタ編集ダイアログの表示です。
     *前回編集した名前が残っているのでリセットします。
     */
    openEditDialog(pfvCode, pfvName) {
      this.editingCluster.id = pfvCode
      this.editingCluster.originalName = pfvName
      this.editingCluster.editName = ''
      this.showClusterEditDialog = true
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.contents {
  width: auto;
  max-width: 900px;
  padding-top: var(--spacing-large);
  padding-bottom: var(--spacing-large);
}
.title-text {
  font-size: var(--font-size-large);
}
.dialog-window {
  min-width: 400px;
}
.pfv-graph {
  margin-bottom: var(--spacing-large);
}
.contents {
  width: auto;
  max-width: 900px;
}
</style>
